import { ReactNode } from 'react';

import { BreakPoints, Icon, Text } from '@kanda-libs/ks-design-library';

interface PleaseWaitOverlayProps {
  icon?: string;
  iconStoke?: string;
  iconClassName?: string;
  title: string;
  header?: JSX.Element;
  labelLine1: string | JSX.Element;
  labelLine2?: string | JSX.Element;
  labelLine3?: string | JSX.Element;
  footer?: ReactNode;
  isLoading?: boolean;
}

const PleaseWaitOverlay = ({
  icon,
  iconStoke,
  iconClassName,
  title,
  header,
  labelLine1,
  labelLine2,
  labelLine3,
  isLoading,
  footer,
}: PleaseWaitOverlayProps) => (
  <div className="flex flex-col w-full mx-auto max-w-100">
    <BreakPoints
      mobile={
        <Icon
          icon={icon}
          size={36}
          className={iconClassName}
          stroke={iconStoke}
          isLoading={isLoading}
        />
      }
      desktop={
        <Icon
          icon={icon}
          size={36}
          className={iconClassName}
          stroke={iconStoke}
          isLoading={isLoading}
        />
      }
    />
    {header}
    <Text
      text={title}
      className="mb-3 text-18-22-em md:text-20-24-em  md:text-neutral-900 md:mb-6"
      isLoading={isLoading}
      skeletonProps={{
        count: 2,
      }}
    />
    <Text
      text={labelLine1}
      className="text-14-22 text-neutral-800"
      isLoading={isLoading}
      skeletonProps={{
        count: 3,
      }}
    />
    {labelLine2 && (
      <Text
        text={labelLine2}
        className="mt-2 text-14-22 text-neutral-800 mt:mb-4"
        isLoading={isLoading}
        skeletonProps={{
          count: 2,
        }}
      />
    )}
    {labelLine3 && (
      <Text
        text={labelLine3}
        className="mt-2 text-14-22 text-neutral-800 mt:mb-4"
        isLoading={isLoading}
        skeletonProps={{
          count: 2,
        }}
      />
    )}
    {footer}
  </div>
);

PleaseWaitOverlay.defaultProps = {
  icon: 'icon',
  iconStoke: 'neutral-700',
  iconClassName: 'mb-4',
  labelLine2: '',
  labelLine3: '',
  isLoading: false,
};

export default PleaseWaitOverlay;
